// Gravure Printing Troubleshooting Guide - Complete Data
// 11 Defects with full technical content

export const troubleshootingData = [
  {
    id: 1,
    slug: "doctor-blade-streaking",
    defectName: "Doctor Blade Streaking",
    metaTitle: "Gravure Printing Doctor Blade Streaking – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Doctor Blade Streaking in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Doctor blade streaking appears as continuous or intermittent lines in the direction of printing. These streaks reduce print clarity and are especially noticeable in solid areas and backgrounds.",
    commonSymptoms: [
      "Vertical or longitudinal lines on print",
      "Uneven ink laydown",
      "Loss of solid density",
      "Repeating marks at regular intervals"
    ],
    probableCauses: [
      "Worn or damaged doctor blade edge",
      "Inconsistent blade pressure across cylinder width",
      "Contaminants or dried ink on blade edge",
      "Incorrect blade angle",
      "Excessively high ink viscosity",
      "Pigment agglomeration in ink"
    ],
    inkRelatedCauses: [
      "Poor pigment dispersion",
      "Incompatible solvent blend",
      "Excessive resin content leading to high film build",
      "Ink drying too fast at the doctor blade"
    ],
    recommendedSolutions: [
      "Replace or regrind doctor blades regularly",
      "Ensure uniform blade pressure and correct blade angle",
      "Filter ink to remove contaminants and dried particles",
      "Optimize ink viscosity to recommended operating range",
      "Improve pigment dispersion quality",
      "Adjust solvent balance to control drying rate at blade edge"
    ],
    pressSideBestPractices: [
      "Clean doctor blade holder frequently",
      "Avoid excessive press speeds during long runs",
      "Maintain consistent ink circulation and filtration",
      "Monitor temperature rise in ink tray"
    ],
    crimsonRecommendation: "Use gravure inks with controlled rheology, fine pigment dispersion, and balanced solvent evaporation profile. These characteristics minimize blade build-up and ensure smooth ink transfer."
  },
  {
    id: 2,
    slug: "pinholes-solvent-popping",
    defectName: "Pinholes & Solvent Popping",
    metaTitle: "Gravure Printing Pinholes & Solvent Popping – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Pinholes & Solvent Popping in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Pinholes appear as tiny craters or voids in the printed ink film, often caused by trapped solvent vapors escaping during drying.",
    commonSymptoms: [
      "Small holes or craters in printed areas",
      "Poor surface smoothness",
      "Reduced gloss and film integrity"
    ],
    probableCauses: [
      "Excessively fast solvent evaporation",
      "High ink film thickness",
      "Inadequate drying capacity",
      "Moisture contamination in ink or substrate",
      "Incorrect solvent blend"
    ],
    inkRelatedCauses: [
      "High boiling solvent imbalance",
      "Excessive retarder usage",
      "Resin incompatibility causing poor film formation"
    ],
    recommendedSolutions: [
      "Rebalance solvent system (fast vs slow solvents)",
      "Reduce ink film thickness",
      "Improve air flow and drying efficiency",
      "Ensure moisture-free solvents and substrates",
      "Optimize retarder levels"
    ],
    pressSideBestPractices: [
      "Avoid excessive ink laydown",
      "Increase dryer efficiency gradually",
      "Maintain proper press room humidity"
    ],
    crimsonRecommendation: "Select inks engineered for smooth solvent release, uniform film formation, and stable drying across press speeds."
  },
  {
    id: 3,
    slug: "color-variation-shade-fluctuation",
    defectName: "Color Variation & Shade Fluctuation",
    metaTitle: "Gravure Printing Color Variation & Shade Fluctuation – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Color Variation & Shade Fluctuation in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Color variation refers to visible shade differences during a print run or between print batches.",
    commonSymptoms: [
      "Shade variation across web width",
      "Batch-to-batch color inconsistency",
      "Density fluctuation during long runs"
    ],
    probableCauses: [
      "Ink viscosity variation",
      "Solvent evaporation imbalance",
      "Poor ink circulation",
      "Temperature variation",
      "Inconsistent cylinder engraving depth"
    ],
    inkRelatedCauses: [
      "Poor color strength stability",
      "Inadequate pigment dispersion",
      "Resin-solvent incompatibility"
    ],
    recommendedSolutions: [
      "Maintain constant ink viscosity",
      "Use closed ink circulation systems",
      "Control solvent evaporation rate",
      "Standardize ink dilution procedures"
    ],
    pressSideBestPractices: [
      "Monitor viscosity continuously",
      "Maintain consistent press temperature",
      "Avoid frequent solvent additions without measurement"
    ],
    crimsonRecommendation: "Use high-strength gravure inks with excellent shade stability, consistent rheology, and high batch-to-batch reproducibility."
  },
  {
    id: 4,
    slug: "poor-adhesion-substrate",
    defectName: "Poor Adhesion on Substrate",
    metaTitle: "Gravure Printing Poor Adhesion on Substrate – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Poor Adhesion on Substrate in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Poor adhesion occurs when the ink film does not bond properly with the substrate, leading to peeling, flaking, or ink removal during post-processing.",
    commonSymptoms: [
      "Ink peeling during tape test",
      "Ink removal during lamination or slitting",
      "Poor rub resistance",
      "Print failure after conversion"
    ],
    probableCauses: [
      "Low surface energy of substrate",
      "Inadequate surface treatment (corona/plasma)",
      "Contamination on substrate surface",
      "Incorrect resin selection",
      "Over-drying of ink film"
    ],
    inkRelatedCauses: [
      "Resin incompatible with substrate",
      "Excessive wax or slip additives",
      "Improper solvent balance affecting wetting"
    ],
    recommendedSolutions: [
      "Increase surface treatment to required dyne level",
      "Ensure clean, contamination-free substrate",
      "Select ink system compatible with substrate chemistry",
      "Optimize solvent blend to improve wetting",
      "Avoid over-drying before lamination"
    ],
    pressSideBestPractices: [
      "Verify dyne level before printing",
      "Avoid printing on aged or improperly stored films",
      "Control drying temperature and air volume"
    ],
    crimsonRecommendation: "Use adhesion-optimized gravure inks designed for excellent substrate wetting and strong intercoat and lamination bond strength."
  },
  {
    id: 5,
    slug: "foaming-air-entrapment",
    defectName: "Foaming & Air Entrapment",
    metaTitle: "Gravure Printing Foaming & Air Entrapment – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Foaming & Air Entrapment in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Foaming occurs when air becomes trapped in the ink, creating bubbles that interfere with smooth ink transfer and film formation.",
    commonSymptoms: [
      "Bubbles in ink tray",
      "Pinholes or craters on print",
      "Uneven ink laydown"
    ],
    probableCauses: [
      "High press speed",
      "Excessive ink agitation",
      "Inappropriate solvent blend",
      "Contaminated ink system"
    ],
    inkRelatedCauses: [
      "High surface tension ink",
      "Incorrect defoamer selection or dosage",
      "Resin incompatibility"
    ],
    recommendedSolutions: [
      "Reduce ink circulation turbulence",
      "Use suitable defoamer in controlled dosage",
      "Optimize solvent composition",
      "Maintain clean ink tanks and lines"
    ],
    pressSideBestPractices: [
      "Avoid excessive ink return heights",
      "Clean ink pumps and hoses regularly",
      "Maintain stable ink viscosity"
    ],
    crimsonRecommendation: "Use low-foaming gravure inks with optimized surface tension and stable defoamer systems."
  },
  {
    id: 6,
    slug: "ink-misting-throw-off",
    defectName: "Ink Misting & Throw-Off",
    metaTitle: "Gravure Printing Ink Misting & Throw-Off – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Ink Misting & Throw-Off in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Ink misting refers to fine ink droplets being thrown off from the cylinder due to centrifugal force at high press speeds.",
    commonSymptoms: [
      "Ink deposits on press components",
      "Print contamination",
      "Poor press cleanliness"
    ],
    probableCauses: [
      "Low ink viscosity",
      "Excessively high press speed",
      "High solvent volatility",
      "Improper doctor blade settings"
    ],
    inkRelatedCauses: [
      "Low molecular weight resin system",
      "Incorrect solvent blend",
      "Poor rheology control"
    ],
    recommendedSolutions: [
      "Increase ink viscosity within recommended limits",
      "Adjust solvent evaporation profile",
      "Optimize doctor blade angle and pressure",
      "Reduce press speed if necessary"
    ],
    pressSideBestPractices: [
      "Maintain proper ventilation",
      "Clean press frequently during long runs",
      "Monitor ink temperature rise"
    ],
    crimsonRecommendation: "Select inks formulated for controlled rheology and reduced misting at high speeds."
  },
  {
    id: 7,
    slug: "drying-problems-solvent-retention",
    defectName: "Drying Problems & Solvent Retention",
    metaTitle: "Gravure Printing Drying Problems & Solvent Retention – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Drying Problems & Solvent Retention in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Solvent retention occurs when solvents remain trapped in the ink film after drying, leading to odor, blocking, or lamination failure.",
    commonSymptoms: [
      "Residual solvent odor",
      "Blocking or sticking of printed rolls",
      "Lamination bond failure"
    ],
    probableCauses: [
      "Inadequate drying capacity",
      "Excessive slow-evaporating solvents",
      "High ink film thickness",
      "Poor air flow"
    ],
    inkRelatedCauses: [
      "Incorrect solvent balance",
      "Excessive retarder content",
      "High resin molecular weight"
    ],
    recommendedSolutions: [
      "Improve dryer air volume and temperature",
      "Rebalance solvent system",
      "Reduce ink film thickness",
      "Optimize press speed"
    ],
    pressSideBestPractices: [
      "Verify dryer efficiency",
      "Maintain clean air ducts",
      "Avoid excessive ink laydown"
    ],
    crimsonRecommendation: "Use fast-release gravure inks engineered for low solvent retention and efficient drying at high speeds."
  },
  {
    id: 8,
    slug: "blocking-set-off",
    defectName: "Blocking & Set-Off",
    metaTitle: "Gravure Printing Blocking & Set-Off – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Blocking & Set-Off in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Blocking occurs when printed surfaces stick together during rewinding or storage.",
    commonSymptoms: [
      "Ink transfer between layers",
      "Damage during roll unwinding",
      "Reduced gloss and appearance"
    ],
    probableCauses: [
      "Incomplete drying",
      "High residual solvent",
      "Excessive ink film thickness",
      "High storage temperature"
    ],
    inkRelatedCauses: [
      "Soft resin system",
      "Inadequate wax or antiblock additives"
    ],
    recommendedSolutions: [
      "Ensure complete drying before rewinding",
      "Reduce ink film thickness",
      "Improve antiblocking formulation",
      "Allow adequate cooling before winding"
    ],
    pressSideBestPractices: [
      "Monitor roll temperature",
      "Avoid tight winding pressure",
      "Allow printed rolls to condition before storage"
    ],
    crimsonRecommendation: "Choose inks with balanced hardness and flexibility, and effective antiblocking systems."
  },
  {
    id: 9,
    slug: "smudging-poor-rub-resistance",
    defectName: "Smudging & Poor Rub Resistance",
    metaTitle: "Gravure Printing Smudging & Poor Rub Resistance – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Smudging & Poor Rub Resistance in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Smudging occurs when the ink film lacks sufficient resistance to rubbing or handling, resulting in ink transfer or surface damage.",
    commonSymptoms: [
      "Ink transfer on handling",
      "Loss of print sharpness",
      "Surface damage during finishing"
    ],
    probableCauses: [
      "Inadequate resin hardness",
      "Incomplete drying",
      "Excessive plasticizer content",
      "Incorrect ink–substrate compatibility"
    ],
    inkRelatedCauses: [
      "Soft resin system",
      "Improper solvent balance",
      "Insufficient crosslinking or film formation"
    ],
    recommendedSolutions: [
      "Use harder resin systems where required",
      "Improve drying efficiency",
      "Optimize solvent balance",
      "Reduce plasticizer levels if applicable"
    ],
    pressSideBestPractices: [
      "Ensure complete drying before handling",
      "Avoid excessive rewinding pressure",
      "Allow adequate conditioning time"
    ],
    crimsonRecommendation: "Use rub-resistant gravure inks formulated for strong film integrity and balanced hardness and flexibility."
  },
  {
    id: 10,
    slug: "gloss-variation",
    defectName: "Gloss Variation",
    metaTitle: "Gravure Printing Gloss Variation – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Gloss Variation in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Gloss variation refers to uneven surface reflectivity across the printed area, affecting visual quality.",
    commonSymptoms: [
      "Patchy or uneven gloss",
      "Dull appearance in solids",
      "Inconsistent finish across web width"
    ],
    probableCauses: [
      "Uneven ink film thickness",
      "Poor pigment dispersion",
      "Solvent evaporation imbalance",
      "Cylinder engraving variation"
    ],
    inkRelatedCauses: [
      "Resin–pigment incompatibility",
      "Excessive filler or extender content",
      "Incorrect solvent blend"
    ],
    recommendedSolutions: [
      "Maintain uniform ink viscosity",
      "Improve dispersion quality",
      "Balance solvent system",
      "Optimize cylinder engraving parameters"
    ],
    pressSideBestPractices: [
      "Maintain consistent press speed",
      "Avoid frequent viscosity corrections",
      "Control press room temperature"
    ],
    crimsonRecommendation: "Choose high-gloss gravure inks with excellent dispersion quality and uniform film formation."
  },
  {
    id: 11,
    slug: "poor-print-sharpness-image-clarity",
    defectName: "Poor Print Sharpness & Image Clarity",
    metaTitle: "Gravure Printing Poor Print Sharpness & Image Clarity – Causes & Solutions | Crimson Inks",
    metaDescription: "Learn the causes of Poor Print Sharpness & Image Clarity in gravure printing and proven ink and press solutions from Crimson Inks' technical experts.",
    introDescription: "Poor print sharpness is characterized by blurred edges, loss of fine detail, and reduced image definition.",
    commonSymptoms: [
      "Blurred text or images",
      "Dot gain",
      "Loss of fine line detail"
    ],
    probableCauses: [
      "Excessive ink spread",
      "Low ink viscosity",
      "Poor doctor blade performance",
      "Substrate absorbency issues"
    ],
    inkRelatedCauses: [
      "Low viscosity formulation",
      "Excessive solvent content",
      "Inadequate rheology control"
    ],
    recommendedSolutions: [
      "Optimize ink viscosity",
      "Improve doctor blade condition",
      "Adjust solvent blend",
      "Use inks with better edge definition"
    ],
    pressSideBestPractices: [
      "Monitor viscosity closely",
      "Maintain sharp doctor blades",
      "Control ink temperature"
    ],
    crimsonRecommendation: "Use precision gravure inks engineered for sharp edge definition, optimal viscosity control, and excellent print clarity."
  }
];

export const getDefectBySlug = (slug) => {
  return troubleshootingData.find(defect => defect.slug === slug);
};

export const getAllDefects = () => {
  return troubleshootingData;
};
